const CODE_DOWN = 40;
const CODE_END = 35;
const CODE_ENTER = 13;
const CODE_ESC = 27;
const CODE_HOME = 36;
const CODE_LEFT = 37;
const CODE_RIGHT = 39;
const CODE_SPACE = 32;
const CODE_UP = 38;

export { CODE_DOWN, CODE_END, CODE_ENTER, CODE_ESC, CODE_HOME, CODE_LEFT, CODE_RIGHT, CODE_SPACE, CODE_UP };
